var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('el-scrollbar',{staticStyle:{"overflow":"hidden","height":"100%"}},[_c('Menus')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }